import { render, staticRenderFns } from "./CreateColor.vue?vue&type=template&id=5ea89c7a&"
import script from "./CreateColor.vue?vue&type=script&lang=js&"
export * from "./CreateColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports